import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from './ui/alert';
import {
  API_VARIANT_NIST,
  API_VARIANT_MINEX,
  normalizeApiVariant,
} from '../biosdkRoutes';

/**
 * Shows a blocking banner when the selected API variant is not supported on the current page.
 * Pass `forVariant` when the message is variant-specific (e.g. NIST finger blocked) so MINEX
 * selection does not inherit another variant's copy.
 */
export default function VariantBlockedBanner({ apiVariant, message, title, forVariant = null }) {
  const variant = normalizeApiVariant(apiVariant);
  if (!message) return null;
  if (forVariant && variant !== forVariant) return null;
  if (variant === API_VARIANT_NIST) {
    return (
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>{title || 'NIST variant not available on this page'}</AlertTitle>
        <AlertDescription>{message}</AlertDescription>
      </Alert>
    );
  }
  if (variant === API_VARIANT_MINEX) {
    return (
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>{title || 'MINEX variant not available on this page'}</AlertTitle>
        <AlertDescription>{message}</AlertDescription>
      </Alert>
    );
  }
  return null;
}
